import React from 'react';

const BentoBox = ({ title, keys, children }) => {
  const svgMap = children.map((svg, index) => {
    return (
      <div key={index} className="svg-container" id={`spec${index}`}>
        <div className="svg-key">{keys[index]}</div>
        {svg}
      </div>
    );
  });

  return (
    <div className="bento-box">
      <div className="bento-title">{title}</div>
      <div className="svg-flex">{svgMap}</div>
    </div>
  );
};

export default BentoBox;
